export default {"src":"/_next/static/media/side-yard-design.208b4c8c.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};